import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";
import { ExternalProps } from "constants/external";

const FormDropdown = () => (
  <ComponentDocs
    name="<Form.Dropdown/>"
    entry="Dropdown"
    propsEntry="DropdownProps"
    namespace="FormFields"
    externalProps={ExternalProps.MuiAutocomplete}
  >
    <ComponentExample
      name="Dropdown options"
      description="A dropdown can be passed an array of options to choose from."
      import={import("examples/Forms/FormDropdown/DropdownOptionsExample")}
      rawImport={import(
        "examples/Forms/FormDropdown/DropdownOptionsExample?raw"
      )}
    />
    <ComponentExample
      name="Dropdown value field"
      description="The valueField prop automatically populates the value of the selected option into a secondary field, to simplify passing the value to an API endpoint."
      import={import("examples/Forms/FormDropdown/DropdownValueFieldExample")}
      rawImport={import(
        "examples/Forms/FormDropdown/DropdownValueFieldExample?raw"
      )}
    />
    <ComponentExample
      name="Lookup connected dropdown"
      description="Dropdown options can be supplied by a registered lookup for data that changes infrequently."
      import={import(
        "examples/Forms/FormDropdown/LookupConnectedDropdownExample"
      )}
      rawImport={import(
        "examples/Forms/FormDropdown/LookupConnectedDropdownExample?raw"
      )}
    />
    <ComponentExample
      name="Auto lookup registration"
      description="The lookupAction prop can be supplied an API action creator for data that changes frequently."
      import={import("examples/Forms/FormDropdown/LookupActionDropdown")}
      rawImport={import("examples/Forms/FormDropdown/LookupActionDropdown?raw")}
    />
    <ComponentExample
      name="Searchable dropdown"
      import={import("examples/Forms/FormDropdown/SearchableDropdownExample")}
      rawImport={import(
        "examples/Forms/FormDropdown/SearchableDropdownExample?raw"
      )}
    />
    <ComponentExample
      name="Multi-select dropdown"
      import={import("examples/Forms/FormDropdown/MultiSelectDropdownExample")}
      rawImport={import(
        "examples/Forms/FormDropdown/MultiSelectDropdownExample?raw"
      )}
    />
    <ComponentExample
      name="Dropdown with additions"
      description="An end user can enter a custom value in a dropdown by using the allowAdditions prop."
      import={import("examples/Forms/FormDropdown/DropdownWithAdditionsExample")}
      rawImport={import(
        "examples/Forms/FormDropdown/DropdownWithAdditionsExample?raw"
      )}
    />
    <ComponentExample
      name="Checkbox filter dropdown"
      import={import(
        "examples/Forms/FormDropdown/CheckboxFilterDropdownExample"
      )}
      rawImport={import(
        "examples/Forms/FormDropdown/CheckboxFilterDropdownExample?raw"
      )}
    />
  </ComponentDocs>
);

export default FormDropdown;
